module.exports = __webpack_public_path__ + "img/sugarfree.98b3ee84.svg";